import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { orderBy } from 'natural-orderby';
import { truncate } from 'underscore.string';
import Modal from 'react-modal';

import UploadFile from '../../../../components/Input/UploadFile';
import Searchbar from '../../../../components/Searchbar';
import SpringLoader from '../../../../components/SpringLoader/SpringLoader.js';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';
import placeholderImage from '../../../../assets/images/placeholder.jpg';
import { config } from '../../../../config/index';
const { API_URL, SERVER_URL } = config;

const SupervisorManagement = () => {
  const token = localStorage.getItem('token');
  const [supervisors, setSupervisors] = useState([]);

  const [clientFilters, setClientFilters] = useState([]);
  const [siteFilters, setSiteFilters] = useState([]);
  const [filteredSupervisors, setFilteredSupervisors] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(true);

  const [sites, setSites] = useState([]);
  const [clients, setClients] = useState([]);
  const [uploadClient, setUploadClient] = useState(0);

  const changeUploadClient = (e) => setUploadClient(e.target.value);

  const checkboxHandler = (e) => {
    if (e.target.checked) {
      let updatedSelectedIds = [...selectedIds];

      updatedSelectedIds.push(parseInt(e.target.value));
      setSelectedIds(updatedSelectedIds);
    } else {
      let updatedSelectedIds = [...selectedIds].filter(
        (id) => id !== parseInt(e.target.value)
      );

      setSelectedIds(updatedSelectedIds);
    }
  };

  const checkboxAllOn = (e) => {
    if (e.target.checked) {
      let supervisor_ids = filteredSupervisors.map(
        (supervisor) => supervisor.id
      );
      setSelectedIds(supervisor_ids);
    } else {
      setSelectedIds([]);
    }
  };

  const clientFilterCheckboxHandler = (e) => {
    const client_id = parseInt(e.target.value);

    if (e.target.checked) {
      if (![...clientFilters].some((id) => id === client_id)) {
        const filters = [...clientFilters];
        const filtered = filters.push(client_id);
        setClientFilters(filters);
      }
    } else {
      const filtered = [...clientFilters].filter((id) => id !== client_id);
      setClientFilters(filtered);
    }
  };

  const clientFilterCheckboxAllHandler = (e) => {
    if (e.target.checked) {
      const clientIds = clients.map((client) => client.id);
      setClientFilters(clientIds);
    } else {
      setClientFilters([]);
    }
  };

  useEffect(() => {
    if (clientFilters.length > 0) {
      const filtered = JSON.parse(JSON.stringify(supervisors));

      const newArr = filtered.filter((supervisor) =>
        clientFilters.some((client_id) => client_id === supervisor.client.id)
      );

      setFilteredSupervisors(newArr);
    } else {
      setFilteredSupervisors(supervisors);
    }
  }, [clientFilters]);

  const siteFilterCheckboxHandler = (e) => {
    const site_id = parseInt(e.target.value);

    if (e.target.checked) {
      if (![...siteFilters].some((id) => id === site_id)) {
        const filters = [...siteFilters];
        const filtered = filters.push(site_id);
        setSiteFilters(filters);
      }
    } else {
      const filtered = [...siteFilters].filter((id) => id !== site_id);
      setSiteFilters(filtered);
    }
  };

  const siteFilterCheckboxAllHandler = (e) => {
    if (e.target.checked) {
      const siteIds = sites.map((site) => site.id);
      setSiteFilters(siteIds);
    } else {
      setSiteFilters([]);
    }
  };

  const filterInput = (input, filter) => {
    if (!Array.isArray(filter)) {
      filter = [filter];
    }
    let results = [];
    for (let i = 0; i < input.length; i++) {
      let sites = input[i].sites;
      for (let j = 0; j < sites.length; j++) {
        let id = sites[j].id;
        if (filter.includes(id)) {
          results.push(input[i]);
          break;
        }
      }
    }
    return results;
  };

  useEffect(() => {
    if (siteFilters.length > 0) {
      const supervisorsList = JSON.parse(JSON.stringify(supervisors));

      const newArr = filterInput(supervisorsList, siteFilters);

      setFilteredSupervisors(newArr);
    } else {
      setFilteredSupervisors(supervisors);
    }
  }, [siteFilters]);

  const searchHandler = (e) => {
    let filtered = [...supervisors].filter((supervisor) => {
      let name = `${supervisor.first_name} ${supervisor.last_name}`;
      return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
    });
    setFilteredSupervisors(filtered);
  };

  const deleteSupervisor = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this Supervisor?'
      )
    ) {
      const url = `${API_URL}/supervisor/${id}`;

      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'DELETE',
          withCredentials: true,
          headers: {
            Authorization: token,
          },
        });

        let data = await response.json();

        if (response.ok) {
          ToastUtil.success('Supervisor successfully deleted!');
          window.location.reload();
        } else {
          console.log(data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const deleteSelectedHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete these Supervisors?'
      )
    ) {
      selectedIds.map(async (id) => {
        const url = `${API_URL}/supervisor/${id}`;

        let response = await fetch(url, {
          mode: 'cors',
          method: 'DELETE',
          withCredentials: true,
          headers: {
            Authorization: token,
          },
        });

        let data = await response.json();

        if (!response.ok) {
          console.log(data);
          throw new Error(response.statusText);
        }
      });

      ToastUtil.success('Supervisors successfully deleted!');
      window.location.reload();
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const padding = 90; // adjust this to your needs
  let height = 425 + padding;
  let heightPx = height + 'px';
  let heightOffset = height / 2;
  let offsetPx = heightOffset + 'px';

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: heightPx, // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '50%',
    maxWidth: '50rem',
  };

  const fetchSupervisors = async () => {
    const url = `${API_URL}/supervisor`;
    setLoading(true);
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        let supervisors = data.data;
        let sorted = orderBy(supervisors, [
          (supervisor) => `${supervisor.first_name} ${supervisor.last_name}`,
        ]);

        setSupervisors(sorted);
        setFilteredSupervisors(JSON.parse(JSON.stringify(sorted)));
      } else {
        ToastUtil.error('Failed to fetch supervisors!');
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const fetchClients = async () => {
    let url = `${API_URL}/client`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        const clientsData = data.data;

        setClients(clientsData);
      } else {
        ToastUtil.error('Failed to fetch clients!');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSites = async () => {
    const url = `${API_URL}/sites`;
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let json = await response.json();

      if (response.ok) {
        setSites(json.data);
      } else {
        ToastUtil.error('Sites is not available');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const arrayContainsArray = (superset, subset) => {
    if (0 === subset.length) {
      return false;
    }
    return subset.every(function (value) {
      return superset.indexOf(value) >= 0;
    });
  };

  const init = () => {
    fetchClients();
    fetchSites();
    fetchSupervisors();
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div
      className="container-fluid"
      style={{
        paddingLeft: '2rem',
        paddingRight: '2rem',
        paddingBottom: '4rem',
      }}
    >
      <div className="border-bottom pb-2 py-4 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4 text-brand">Supervisor Management</h6>
        <div className="dropdown">
          <button
            className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-shadow"
            style={{ width: '200px' }}
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Add New
          </button>
          <div
            className="dropdown-menu mt-2"
            style={{ width: '200px' }}
            aria-labelledby="dropdownMenuButton"
          >
            <a
              className="dropdown-item border-bottom pb-2"
              href="#"
              onClick={handleOpenModal}
            >
              Bulk Upload (.CSV)
            </a>
            <Link to="/supervisors/add" className="dropdown-item pt-2">
              Add New
            </Link>
          </div>
        </div>
      </div>
      <div className="d-flex flex-row align-items-center py-3">
        <h6 className="flex-grow-1">
          Supervisor ({filteredSupervisors.length})
        </h6>
        <Searchbar
          search={(e) => searchHandler(e)}
          placeholder="Search supervisor"
        />
        <div className="dropdown">
          <button
            className="btn btn-brand ms-3 adjust-fs adjust-shadow"
            style={{ width: '100px' }}
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i className="fas fa-plus"></i> Filter
          </button>
          <div
            className="dropdown-menu dropdown-menu-right mt-2"
            style={{ width: '300px' }}
            aria-labelledby="dropdownMenuButton"
          >
            <div className="container">
              <div className="d-flex flex-column pb-2">
                <div className="pb-1">
                  <input
                    type="checkbox"
                    name="clientAll"
                    className="me-2"
                    checked={arrayContainsArray(
                      clients.map((client) => client.id),
                      clientFilters
                    )}
                    onChange={(e) => clientFilterCheckboxAllHandler(e)}
                  />{' '}
                  <strong>Clients</strong>
                </div>
                <div className="container">
                  {clients &&
                    clients.map((client) => (
                      <div className="d-flex" key={client.id}>
                        <label>
                          <input
                            type="checkbox"
                            value={client.id}
                            name={`checkboxClient-${client.id}`}
                            className="me-2"
                            checked={clientFilters.some(
                              (id) => id === client.id
                            )}
                            onChange={(e) => clientFilterCheckboxHandler(e)}
                          />
                          {client.name}
                        </label>
                      </div>
                    ))}
                </div>
              </div>
              <div className="d-flex flex-column pb-2">
                <div className="pb-1">
                  <input
                    type="checkbox"
                    name="siteAll"
                    className="me-2"
                    checked={arrayContainsArray(
                      sites.map((site) => site.id),
                      siteFilters
                    )}
                    onChange={(e) => siteFilterCheckboxAllHandler(e)}
                  />
                  <strong>Sites</strong>
                </div>
                <div className="container">
                  {sites &&
                    sites
                      .filter((site) => site.active)
                      .map((site) => (
                        <div className="d-flex" key={site.id}>
                          <label>
                            <input
                              type="checkbox"
                              value={site.id}
                              name={`checkboxSite-${site.id}`}
                              className="me-2"
                              checked={siteFilters.some((id) => id === site.id)}
                              onChange={(e) => siteFilterCheckboxHandler(e)}
                            />
                            {site.name}
                          </label>
                        </div>
                      ))}
                </div>
              </div>
              <div className="d-flex justify-content-end border-top py-2">
                <div
                  className="text-muted fw-bold"
                  style={{ cursor: 'pointer' }}
                >
                  Clear
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table-responsive rounded shadow bg-white">
        <table className="table table-borderless mb-0">
          <thead className="border-bottom">
            <tr>
              <th className="py-3 text-muted fw-normal">
                <div className="form-check">
                  <input
                    className="form-check-input position-static"
                    type="checkbox"
                    onChange={checkboxAllOn}
                  />
                </div>
              </th>
              {selectedIds.length > 0 ? (
                <React.Fragment>
                  <th className="py-3 text-muted fw-normal">Name</th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-danger fw-normal">
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={deleteSelectedHandler}
                    >
                      Delete
                    </div>
                  </th>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <th className="py-3 text-muted fw-normal">Name</th>
                  <th className="py-3 text-muted fw-normal">Employee No.</th>
                  <th className="py-3 text-muted fw-normal">Employee ID</th>
                  <th className="py-3 text-muted fw-normal">Client</th>
                  <th className="py-3 text-muted fw-normal">Sites</th>
                  <th className="py-3 text-muted fw-normal"></th>
                </React.Fragment>
              )}
            </tr>
          </thead>
          <tbody>
            {filteredSupervisors.length > 0 ? (
              filteredSupervisors &&
              filteredSupervisors.map((supervisor) => (
                <tr key={supervisor.id} className="border-bottom">
                  <td>
                    <div className="form-check">
                      <input
                        className="form-check-input position-static"
                        type="checkbox"
                        checked={selectedIds.some((id) => id === supervisor.id)}
                        value={supervisor.id}
                        onChange={checkboxHandler}
                      />
                    </div>
                  </td>
                  <td className="d-flex align-items-center">
                    <img
                      src={
                        supervisor.image
                          ? `${SERVER_URL}/${supervisor.image}`
                          : placeholderImage
                      }
                      alt="default"
                      className="rounded-circle border me-3"
                      style={{ height: '30px', width: '30px' }}
                    />
                    <Link
                      to={`/supervisors/supervisor/${supervisor.id}`}
                      style={{ color: 'inherit', textDecoration: 'none' }}
                    >
                      <strong
                        className={!supervisor.active ? 'text-danger' : ''}
                      >{`${supervisor.first_name} ${supervisor.last_name}`}</strong>
                    </Link>
                  </td>
                  <td>{supervisor.employee_no}</td>
                  <td>{supervisor.employee_id}</td>
                  <td
                    data-toggle="tooltip"
                    data-placement="top"
                    title={supervisor.client ? supervisor.client.name : '-'}
                  >
                    {supervisor.client && truncate(supervisor.client.name, 12)}
                  </td>
                  <td>
                    <div className="d-flex flex-row align-items-center">
                      {supervisor.sites && supervisor.sites.length > 2
                        ? supervisor.sites.slice(0, 2).map((site) => (
                            <span
                              key={site.id}
                              className="badge rounded-pill bg-brand text-white me-1"
                            >
                              {site.name}
                            </span>
                          ))
                        : supervisor.sites.map((site) => (
                            <span
                              key={site.id}
                              className="badge rounded-pill bg-brand text-white me-1"
                            >
                              {site.name}
                            </span>
                          ))}
                      {supervisor.sites.length > 2 && (
                        <div className="fw-bold text-brand">
                          <div
                            style={{ cursor: 'pointer' }}
                            data-toggle="dropdown"
                          >
                            +{supervisor.sites.length - 2}
                          </div>
                          <div
                            className="dropdown-menu dropdown-menu-right"
                            style={{ width: '150px' }}
                          >
                            <div className="container">
                              {supervisor.sites
                                .slice(
                                  supervisor.sites.length - 1,
                                  supervisor.sites.length
                                )
                                .map((site) => (
                                  <span
                                    key={site.id}
                                    className="badge rounded-pill bg-brand text-white me-1"
                                  >
                                    {site.name}
                                  </span>
                                ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                  <td className="text-center">
                    <div
                      style={{ cursor: 'pointer' }}
                      className="dropdown custom-dropdown"
                    >
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i
                          className="fas fa-ellipsis-h"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        ></i>
                      </button>
                      <div
                        className="dropdown-menu dropdown-menu-right"
                        style={{ width: '150px' }}
                      >
                        <Link
                          to={`/supervisors/supervisor/${supervisor.id}/edit`}
                          style={{ cursor: 'pointer' }}
                          className="dropdown-item border-bottom pb-2"
                        >
                          Edit
                        </Link>
                        <div
                          onClick={() => deleteSupervisor(supervisor.id)}
                          style={{ cursor: 'pointer' }}
                          className="dropdown-item pt-2"
                        >
                          Delete
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  {loading ? (
                    <div className="springloader-holder">
                      <SpringLoader></SpringLoader>
                    </div>
                  ) : (
                    <div className="text-center text-muted my-3 pb-4">
                      <i>No results</i>
                    </div>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Modal
        isOpen={showModal}
        style={{
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          content: style,
        }}
      >
        <h3>Upload New Supervisors</h3>
        {
          <div className="py-3 d-flex flex-column">
            <span>Client: </span>
            <select
              className="form-select mt-2"
              value={uploadClient}
              onChange={(e) => changeUploadClient(e)}
            >
              <option value={0}>Choose Client</option>
              {clients &&
                clients.map((client) => (
                  <option value={client.id} key={client.id}>
                    {client.name}
                  </option>
                ))}
            </select>
          </div>
        }
        {parseInt(uploadClient) > 0 && (
          <React.Fragment>
            <p className="text-muted">Drag and drop your file here</p>
            <UploadFile
              url={`${API_URL}/client/${uploadClient}/supervisor/import`}
              handleCloseModal={handleCloseModal}
            />
          </React.Fragment>
        )}
      </Modal>
    </div>
  );
};

export default SupervisorManagement;
